module.exports = __webpack_public_path__ + "bb0feb6c39cd6652e76b6945ee875481.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-68.png
// module id = 140
// module chunks = 0